function skipHello() {
}
function sayHello() {
}

export { sayHello, skipHello };
//# sourceMappingURL=hello.mjs.map
